import { createContext } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

// `parentIds` is the direct-parent set seeded into the form field, never the frozen `ancestorIds` chain.
export type GoalFormSeed = Partial<Goal> & {
  parentIds?: ID[] | null;
};

// A create seeds its parents through `parentIds`; handing it the frozen chain instead is what
// left a new sub-goal without its parent's colour, so the field is out of reach here.
export type CreateGoalOptions = Omit<GoalFormSeed, 'ancestorIds'> & {
  skipNavigation?: boolean;
  tasks?: Task[];
};

export type GoalFormContextProps = {
  onCreateGoal: (options?: CreateGoalOptions) => void;
  onEditGoal: (initialValues: Partial<Goal>, id: ID) => void;
};

export const GoalFormContext = createContext<GoalFormContextProps>({
  onCreateGoal: () => {},
  onEditGoal: () => {},
});
